export default {"src":"/_next/static/media/check.cc94d062.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};